<patternlib-language-picker-service
  [selected]="activeLanguage?.value"
  [show]="showLanguageFlyout"
  [options]="languages"
  (lhLanguageSelect)="selectLanguage($event)"
></patternlib-language-picker-service>
